module.exports = __webpack_public_path__ + "img/password-lock-2.bcaa0abb.svg";